
















import {
  EstatisticaLeadService,
  ResultadoMotivo,
} from "@/services/estatistica-lead.service";
import ChartBar from "@/shared/components/chart-bar.vue";
import moment from "moment";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { motivoLead } from "../../filters/filters";

const colors: { [key: number]: string } = {
  0: "#3fa9f5",
  1: "#ab248b",
  2: "#00c486",
  3: "#ff0000",
  4: "#38499c",
  5: "#83cf00",
};

@Component({
  components: {
    ChartBar,
  },
})
export default class GraficoResultadoPorMotivo extends Vue {
  loading = false;
  dados: ResultadoMotivo[] | null = null;
  @Prop({ required: true }) readonly data!: string;
  readonly options: Chart.ChartOptions | Chart.ChartLineOptions = {
    legend: {
      display: false,
    },
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: "index",
    },
    scales: {
      yAxes: [
        {
          ticks: {
            precision: 0,
            beginAtZero: true,
          },
        },
      ],
    },
  };

  get labels() {
    return this.dados?.map((x) => motivoLead(x.idMotivoLead) || "Sem motivo");
  }
  get dataSets(): Chart.ChartDataSets[] {
    return (
      [
        {
          label: "Quantidade",
          backgroundColor: this.dados?.map((_, i) => colors[i % 6]) || [],
          data: this.dados?.map((x) => x.quantidade),
        },
      ] || []
    );
  }

  mounted() {
    this.fetchData();
  }

  @Watch("data")
  async fetchData() {
    this.loading = true;
    try {
      this.dados = await EstatisticaLeadService.listarResultadoMotivos(
        moment(`${this.data}-01`).toDate()
      );
    } finally {
      this.loading = false;
    }
  }
}
